import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAppSelector, useAppDispatch } from '../../store/hooks'
import { setProfile } from '../../store/authSlice'
import { supabase } from '../../services/supabaseClient'
import NavBack from '../base/NavBack'

export default function EditProfileScreen() {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const profile = useAppSelector((s) => s.auth.profile)
  const [displayName, setDisplayName] = useState(profile?.display_name ?? '')
  const [role, setRole] = useState(profile?.role ?? '')
  const [saving, setSaving] = useState(false)
  const [error, setError] = useState('')
  const [status, setStatus] = useState('')

  const initials = displayName
    ? displayName.split(' ').map((n) => n[0]).join('').toUpperCase().slice(0, 2)
    : '?'

  const handleSave = async () => {
    if (!displayName.trim()) { setError('Please enter your name.'); return }
    if (!profile) return
    setSaving(true)
    setError('')
    setStatus('')

    const { error: dbError } = await supabase
      .from('profiles')
      .update({ display_name: displayName.trim(), role: role.trim() || null })
      .eq('id', profile.id)

    if (dbError) {
      setError(dbError.message)
      setSaving(false)
      return
    }

    dispatch(setProfile({
      ...profile,
      display_name: displayName.trim(),
      role: role.trim() || null,
    }))
    setStatus('Profile saved.')
    setSaving(false)
    setTimeout(() => navigate('/'), 800)
  }

  return (
    <div className="onboard-wrap" data-testid="edit-profile-screen">
      <div className="onboard-box">
        <NavBack label="Dashboard" onClick={() => navigate('/')} />
        <h2>Edit Your Profile</h2>
        <div className="profile-preview" data-testid="edit-profile-preview">
          <div className="user-avatar user-avatar-lg" data-testid="edit-profile-avatar">{initials}</div>
        </div>
        <input
          type="text"
          className="gate-input"
          placeholder="Your name"
          value={displayName}
          onChange={(e) => setDisplayName(e.target.value)}
          data-testid="edit-profile-name-input"
        />
        <input
          type="text"
          className="gate-input"
          placeholder="Job title (optional)"
          value={role}
          onChange={(e) => setRole(e.target.value)}
          data-testid="edit-profile-role-input"
        />
        {error && <div className="gate-err" data-testid="edit-profile-error">{error}</div>}
        {status && <div className="gate-err" style={{ color: 'var(--blue)' }} data-testid="edit-profile-status">{status}</div>}
        <button
          className="btn btn-primary gate-btn"
          disabled={saving || !displayName.trim()}
          onClick={handleSave}
          data-testid="edit-profile-save-btn"
        >
          {saving ? 'Saving...' : 'Save changes'}
        </button>
        <button
          className="btn gate-btn"
          onClick={() => navigate('/')}
          data-testid="edit-profile-cancel-btn"
        >
          Cancel
        </button>
      </div>
    </div>
  )
}
